import { createSelector } from "reselect";
import { isEmpty, get } from "lodash";
import { forms } from "utils/constants";

const directPayLinkValidDomain = state =>
  get(state, "api.directPayLinkInfo.data", {});

const directPayLinkErrorDomain = state =>
  get(state, "api.directPayLinkInfo.error", {});

export const makeSelectDirectPayLinkDetail = () => directPayLinkValidDomain;

export const makeSelectDirectPaymentDetail = () =>
  createSelector(directPayLinkValidDomain, detail => {
    return get(detail, "formData", {});
  });

export const makeSelectIsValidPaymentLink = () =>
  createSelector(directPayLinkValidDomain, detail => {
    const isValid = !isEmpty(detail);
    return {
      isValid
    };
  });

export const makeSelectIsFetchingLinkDetail = () =>
  createSelector(
    directPayLinkValidDomain,
    directPayLinkErrorDomain,
    (validDetail, errorDetail) => {
      const isLoading = isEmpty(validDetail) && isEmpty(errorDetail);
      return isLoading;
    }
  );

export const directPayLinkFormSelector = state => {
  return get(state, `form.${forms.DIRECT_PAY_LINK_FORM}.values`, {});
};

export const makeSelectPayLinkInfo = () => directPayLinkFormSelector;

export const directPayLinkInfoSelector = createSelector(
  directPayLinkValidDomain,
  formValues => {
    return {
      email: get(formValues, "email"),
      full_name: get(formValues, "customerName"),
      invoice_id: get(formValues, "invoiceId")
        ? get(formValues, "invoiceId")
        : get(formValues, "external_ref")
    };
  }
);

export const makeSelectDirectPayLinkInfo = () => directPayLinkInfoSelector;
